import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home_line",
  "use": "icon-home_line-usage",
  "viewBox": "0 0 1 39.043",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1 39.043\" id=\"icon-home_line\"><defs><style>#icon-home_line .a{fill:none;stroke:#ededed;stroke-linecap:round;}</style></defs><line class=\"a\" y2=\"38.043\" transform=\"translate(0.5 0.5)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol